export class ScriptLoader {
    constructor() {
        this.registry = new Map();
    }
    static get default() {
        return ScriptLoader._default = ScriptLoader._default ?? new ScriptLoader();
    }
    async loadScript(url) {
        const entry = this.registry.get(url) ?? { loaded: false };
        this.registry.set(url, entry);
        if (entry.loaded) {
            return true;
        }
        else if (entry.currentPromise) {
            const result = await entry.currentPromise;
            if (result)
                return true;
        }
        entry.currentPromise = new Promise(resolve => {
            const scriptElement = document.createElement("script");
            scriptElement.type = "text/javascript";
            scriptElement.src = url;
            scriptElement.async = true;
            scriptElement.onload = function () {
                console.log("Script loaded: ", url);
                entry.loaded = true;
                entry.currentPromise = undefined;
                resolve(true);
            };
            scriptElement.onerror = function () {
                console.log("Script loading failed: ", url);
                scriptElement.remove();
                entry.currentPromise = undefined;
                resolve(false);
            };
            document.head.appendChild(scriptElement);
        });
        return entry.currentPromise;
    }
}
//# sourceMappingURL=script-loader.js.map